$(function() {

    let $selects = $('.form_select');
    $.each($selects, function($key, select) {
       changeSelect($(select));
    });

    $('.form_select').on('change', function() {
        changeSelect($(this));
    });

    /**
     * プルダウンが変更されたとき子プルダウンがあればその値を
     * 選択された値によって、書き換える。
     * @param {select element}} $this
     */
    function changeSelect($this) {
        let parent_id = $this.val();
        let this_tier = $this.data('tier');
        let child_dier = this_tier + 1;
        let child_id = 'select_' + child_dier;

        if (!$('#' + child_id)) {
            return;
        }

        this_tier++;
        let select_html = '';
        let value = '';
        if (options[parent_id]) {
            let i = 0;
            let is_label = 0;
            let selected = '';
            $.each(options[parent_id], function(key, option) {
                if(0 == i) {
                    value = '';
                } else {
                    value = option.id;
                }
                if (option.label.match(/^__/)) {
                    if (is_label) {
                        select_html += '</optgroup'> + "\n";
                    }
                    select_html += '<optgroup label="' + option.label.replace('__', '') + '">' + "\n";
                    is_label = 1;
                } else {
                    selected = option.selected ? ' selected="selected"' : '';
                    select_html += '<option value="' + value + '" ' + selected + '>' +  option.label + '</option>' + "\n";
                }
                i++;
            })
            if (is_label) {
                select_html += '</optgroup'> + "\n";
            }
        }
        $('#' + child_id).html(select_html);
    }
});

